import { Mail, Clock, Users } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";
import { jugend } from "@/data/content";

const Jugend = () => (
  <section id="jugend" className="grain relative bg-fw-paper py-24 md:py-32" data-testid="jugend-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeader kicker="Nachwuchs" title={jugend.title} subtitle={jugend.subtitle} testId="jugend-header" />

      <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
        <Reveal className="grid grid-cols-2 gap-4">
          {jugend.images.map((src, i) => (
            <div
              key={i}
              className={`overflow-hidden border-2 border-fw-green/60 p-1.5 bg-white ${i === 0 ? "col-span-2" : ""}`}
            >
              <img src={src} alt="Jugendfeuerwehr" className="w-full aspect-video object-cover transition-transform duration-700 hover:scale-105" />
            </div>
          ))}
        </Reveal>

        <div>
          <Reveal>
            <p className="font-body text-lg text-fw-navy/80">{jugend.text}</p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 border-l-4 border-fw-green bg-white p-7 shadow-[8px_8px_0px_rgba(46,139,61,0.15)]" data-testid="jugend-cta">
              <h3 className="font-heritage text-3xl text-fw-red">{jugend.cta.headline}</h3>
              <p className="mt-2 font-body text-fw-navy/70">{jugend.cta.text}</p>
              <a
                href={`mailto:${jugend.cta.email}`}
                className="mt-3 inline-flex items-center gap-2 font-technical uppercase tracking-wide text-fw-blue hover:text-fw-red"
                data-testid="jugend-email-link"
              >
                <Mail className="h-4 w-4" /> {jugend.cta.email}
              </a>
              <div className="mt-6 space-y-3 border-t border-fw-navy/10 pt-5">
                <p className="flex items-start gap-3 font-body text-sm text-fw-navy/80">
                  <Clock className="h-5 w-5 text-fw-green shrink-0" /> <span><strong className="font-semibold">Übungsabend:</strong> {jugend.cta.uebung}</span>
                </p>
                <p className="flex items-start gap-3 font-body text-sm text-fw-navy/80">
                  <Users className="h-5 w-5 text-fw-green shrink-0" /> <span><strong className="font-semibold">Eintrittsalter:</strong> {jugend.cta.eintritt}</span>
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Jugend;
